module.exports = __webpack_public_path__ + "img/symbol_6.e7a08b05.png";